// Shared renderer for a single TSC garment tag using the layout config.
// Used by both the Tag Layout Editor (preview) and BillView (real print).
import React from "react";

const alignMap = { left: "left", center: "center", right: "right" };

// data: { brand, order, name, mobile, service, item, piece, delivery, footer, custom_1?, custom_2?, ... }
export const renderTag = (layout, data, keyId = "tag") => {
  const style = {
    width: `${layout.width_mm}mm`,
    height: `${layout.height_mm}mm`,
  };
  return (
    <div key={keyId} className="tsc-tag" style={style} data-testid={`tsc-tag-${keyId}`}>
      {layout.fields.filter((f) => f.enabled).map((f) => {
        // Custom text field uses the layout's own `value`; standard fields use bill data.
        const val = f.isCustom ? (f.value || "") : data[f.key];
        if (val === undefined || val === null || val === "") return null;
        const s = {
          fontSize: `${f.size}px`,
          fontWeight: f.bold ? 800 : 400,
          textAlign: alignMap[f.align] || "left",
          textDecoration: f.underline ? "underline" : "none",
        };
        if (f.key === "item") {
          return <div key={`${f.key}-${keyId}`} className="tsc-tag-item" style={{ ...s, textTransform: "uppercase" }}>{val}</div>;
        }
        if (f.key === "brand") {
          return <div key={`${f.key}-${keyId}`} className="tsc-tag-brand" style={{ ...s, letterSpacing: "0.15em", borderBottom: "1px solid #000", paddingBottom: "1mm" }}>{val}</div>;
        }
        if (f.isCustom || f.key === "footer") {
          return <div key={`${f.key}-${keyId}`} style={{ ...s, marginTop: "1mm" }}>{val}</div>;
        }
        return (
          <div key={`${f.key}-${keyId}`} className="tsc-tag-row" style={{ ...s, display: "flex", justifyContent: "space-between" }}>
            <span style={{ fontWeight: 400 }}>{f.label}</span>
            <b>{val}</b>
          </div>
        );
      })}
    </div>
  );
};

export const buildTagData = ({ brand_text, footer_text }, bill, item, pieceNo, totalPcs, formatDate) => ({
  brand: brand_text || "QUICK WASH",
  order: bill.bill_number,
  name: bill.customer_name,
  mobile: bill.mobile,
  service: item.service,
  item: item.item,
  piece: `${pieceNo} / ${totalPcs}`,
  delivery: formatDate(bill.delivery_date),
  footer: footer_text || "",
});
